import i18next from 'i18next';

import { trackSentryError } from './analytics/sentry';
import { getDirectUrl } from './env';
import { ApiError } from './api';

export async function generateImage(
  userId: string,
  campaignId: string,
  structuredGroupId: string,
  itemId: string,
  prompt: string,
  session: string,
  retry?: boolean
): Promise<void> {
  try {
    const response = await fetch(getDirectUrl('generate_image'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id: userId,
        campaign_id: campaignId,
        structured_group_id: structuredGroupId,
        structured_item_id: itemId,
        prompt: prompt,
        submitter: session,
        ...(retry && { retry: true }),
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new ApiError(
        errorData,
        response.status,
        i18next.t('app.errors.imageGenerationFailed')
      );
    }
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    trackSentryError(errorMessage);
    if (error instanceof ApiError) {
      throw error;
    } else {
      throw new ApiError(i18next.t('app.errors.imageGenerationFailed'), 0);
    }
  }
}

export async function deleteImage(
  userId: string,
  campaignId: string,
  structuredGroupId: string,
  itemId: string,
  imageId: string
): Promise<void> {
  try {
    const response = await fetch(getDirectUrl('delete_image'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id: userId,
        campaign_id: campaignId,
        structured_group_id: structuredGroupId,
        structured_item_id: itemId,
        image_id: imageId,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new ApiError(
        errorData,
        response.status,
        i18next.t('app.errors.imageDeletionFailed')
      );
    }
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    trackSentryError(errorMessage);
    if (error instanceof ApiError) {
      throw error;
    } else {
      throw new ApiError(i18next.t('app.errors.imageDeletionFailed'), 0);
    }
  }
}
